import React, { useEffect, useState } from "react";
import InvoiceTabComments from "./InvoiceTabComments";
import { useTranslation } from "react-i18next";
import TabsNavbar from "../../Common/TabsNavBar/TabsNavbar";
import { useDispatch, useSelector } from "react-redux";
import { getFavorites, resetFavorites } from "../../../REDUX/actions/favorites";
import Favorites from "../../Common/Favorites/Favorites";
import { isDefined } from "../../../Utils";

const InvoiceComments = ({ id, slug }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation("common");
  const [activeTab, setActiveTab] = useState("Comments");
  const { favorites } = useSelector((state) => state.favoriteReducer);

  const [scrollableComment, setScrollableComment] = useState();
  const tabs = ["Comments"];

  if (favorites?.length > 0) {
    tabs.push("Favorites");
  }

  useEffect(() => {
    if (!isDefined(id)) return;

    dispatch(getFavorites(id, "facture"));

    return () => dispatch(resetFavorites());
  }, [id, dispatch]);

  return (
    <div className="newApporteurAffaire d-flex flex-column justify-content-between h100">
      <div className="h-100 d-flex flex-column">
        <h2 className="sBold f25 quickSand text-blue px-5 mb-5">
          {`${t("The invoice")} #${slug}`}
        </h2>
        <TabsNavbar
          tabs={tabs}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          className="gap-5"
        />
        {activeTab === "Comments" && (
          <InvoiceTabComments
            id={id}
            scrollableComment={scrollableComment}
            setScrollableComment={setScrollableComment}
          />
        )}
        {activeTab === "Favorites" && (
          <Favorites
            view="INVOICE"
            setActiveTab={setActiveTab}
            setScrollableComment={setScrollableComment}
          />
        )}
      </div>
    </div>
  );
};

export default InvoiceComments;
